import $ from 'jquery';

export default function () {
    $('[data-redirect]').each(function () {
        window.location.href = $(this).attr('data-redirect');
    });
}


// WEBPACK FOOTER //
// ./App/components/modules/redirect.js